import { motion } from 'motion/react';
import { useEffect, useMemo } from 'react';
import useLocalStorage from '../../hooks/useLocalStorage';

const names = {
  S7: 'mascot1',
  S8: 'mascot2',
  S9: 'mascot3',
  S10: 'moreNoise',
  S11: 'supportTheTeam',
};

const defaultName = 'mascot1';

export const Player = ({ currentState }) => {
  const [playerNumber, setPlayerNumber] = useLocalStorage(
    'player',
    defaultName
  );

  useEffect(() => {
    if (!Object.values(names).includes(playerNumber)) {
      setPlayerNumber(defaultName);
    }
  }, []);

  useEffect(() => {
    const playerStates = ['S7', 'S8', 'S9', 'S10', 'S11'];
    if (!currentState || !playerStates.includes(currentState)) {
      return;
    }

    setPlayerNumber(names[currentState]);
  }, [currentState]);

  const srcVideoPlayer = useMemo(() => {
    const protocol = window?.location.protocol || 'https:';
    return `${protocol}//stream-test.iactive.pro/dinamo-altai-hk/videos/${playerNumber}.webm`;
  }, [playerNumber]);

  return (
    <motion.div
      key={srcVideoPlayer}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{ width: '100%', height: '100%' }}
    >
      <video autoPlay="autoplay" muted="muted" loop id="bgVideo1">
        <source src={srcVideoPlayer} type="video/webm" />
      </video>
    </motion.div>
  );
};
